<template>
    <kiosk-layout formContainer>
        <step-form-heading :icon="faGrid2Plus"> New Group </step-form-heading>

        <form-wrapper
            :sections="[
                { id: 'details', label: 'Details' },
                { id: 'attributes', label: 'Custom Attributes' },
            ]"
        >
            <kiosk-group-form-details id="details" v-model="form" />

            <kiosk-group-form-custom-attributes id="attributes" v-model="customAttributes" />

            <vx-sticky-footer>
                <vx-button href="/kiosk/groups" class="w-20" size="lg" color="muted"> Cancel </vx-button>
                <vx-button
                    @click="submit()"
                    data-test="submit-button"
                    class="grow"
                    size="lg"
                    color="primary"
                    :loading="processing"
                >
                    Create Group
                </vx-button>
            </vx-sticky-footer>
        </form-wrapper>
    </kiosk-layout>
</template>

<script setup>
import KioskLayout from '../../KioskLayout.vue';
import StepFormHeading from '~/components/general/StepFormHeading.vue';
import FormWrapper from '~/components/general/FormWrapper.vue';
import { VxStickyFooter, VxButton } from '@voxie/frontend-components';
import { ref } from 'vue';
import KioskGroupFormDetails from './KioskGroupFormDetails.vue';
import KioskGroupFormCustomAttributes from './KioskGroupFormCustomAttributes.vue';
import { useFormSubmission } from '~/composables/useFormSubmission';
import { adminGroupsClient } from '~/services';
import { faSquareArrowUpLeft, faGrid2Plus } from '@fortawesome/pro-solid-svg-icons';

const defaultData = () => ({
    group_id: '',
    team_id: null,
    name: '',
    time_zone: null,
    hubspot_company_id: null,
});
const form = ref(defaultData());

const customAttributes = ref([]);

const save = async () => {
    const response = await adminGroupsClient.createGroup(form.value.team_id, {
        group_id: form.value.group_id,
        name: form.value.name,
        time_zone: form.value.time_zone,
        hubspot_company_id: form.value.hubspot_company_id,
        custom_attributes: customAttributes.value,
    });
    return response;
};

const { submit, processing } = useFormSubmission({
    data: form,
    submit: save,
    preserveScroll: false,
    reset: () => {
        // if update functionality is added to this form, the data should not be cleared
        form.value = defaultData();
        customAttributes.value = [];
    },
    notification: () => ({
        message: 'Group created',
        action: {
            icon: faSquareArrowUpLeft,
            label: 'Back to Groups',
            href: '/kiosk/groups',
        },
    }),
});
</script>
